import { render } from "./desconsiderar-atividade.vue?vue&type=template&id=4b00e8cc"
import script from "./desconsiderar-atividade.js?vue&type=script&lang=js&external"
export * from "./desconsiderar-atividade.js?vue&type=script&lang=js&external"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__